import React  from 'react'

import {FieldViewProps} from "../../../../render/view"
import FieldRAG_Icon from "../../../../generic/rag/components/rag-icon"
import {ColorPalette} from "../../../../color-coding/color-coding"

export default function FieldGoalHealth_View(props:FieldViewProps) {

    const value = _.get(props.model, props.field.fieldId, null)
    const option = props.field._getOption(value)

    const style = {
        color           : gd.skin.colors.mainColor({
            colorNumber     : option?.color,
            corePalette     : ColorPalette.SYSTEM
        })
    }

    return (
        <div className={Classes("flex-row-left-center", props.className)}>
            <FieldRAG_Icon className="fl-ac m-r-5" option={option}/>
            <div className="ui5-txt-default txt-truncate" style={style}>
                {option?.label}
            </div>
        </div>
    )
}
